/**
 * Placeholder.jsx
 * Honest stand-in for screens whose phase hasn't been built yet.
 */

import { Clock } from './Icons.jsx';

export default function Placeholder({ eyebrow, title, phase, children }) {
  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-head__eyebrow">{eyebrow || title}</div>
          <h1>{title}</h1>
          <p>Not built yet — scheduled for {phase}.</p>
        </div>
      </div>

      <div className="card">
        <div className="empty">
          <div className="empty__art">
            <Clock size={30} />
          </div>
          <h3>{phase}</h3>
          <p>{children}</p>
        </div>
      </div>
    </>
  );
}
